import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalSettingsStores from '../../../../stores/settings-stores';
import {
  PollWithQuestionsResponse,
  PollQuestionType,
} from '../../../../api/types/settings/settings-all';

export const duplicatePollOperation = async (
  originalPoll: PollWithQuestionsResponse,
  newPollName: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (newPollName.length < 2 || newPollName.length > 100) {
      toast.warn('על שם המשוב להיות בין 2 ל100 תווים');
      return;
    }
    setLoading(true);

    // Step 1: Create the new poll
    const createPollResponse = await appApi.createAbstractPoll(newPollName);
    if (createPollResponse.data.errCode) {
      toast.error('לא ניתן ליצור את המשוב, נסה שוב בעוד מספר רגעים');
      setLoading(false);
      return;
    }

    // Refresh settings to get the new poll ID
    await globalSettingsStores.fetchSetting();
    const newPoll = globalSettingsStores.abstractPolls.find(
      (p) => p.pollName === newPollName,
    );

    if (!newPoll) {
      toast.error('לא ניתן למצוא את המשוב החדש שנוצר');
      setLoading(false);
      return;
    }

    // Step 2: Duplicate all questions from the original poll
    // Sort questions by order to maintain the same order
    const sortedQuestions = [...(originalPoll.questions || [])].sort(
      (a, b) => a.questionOrder - b.questionOrder,
    );

    for (const question of sortedQuestions) {
      // Prepare options if it's a multiple choice question
      const options =
        question.questionType === PollQuestionType.multiple_choice &&
        question.options
          ? question.options
              .sort((a, b) => a.optionOrder - b.optionOrder)
              .map((option) => ({
                optionText: option.optionText,
                optionValue: option.optionValue,
                optionOrder: option.optionOrder,
              }))
          : undefined;

      // Create the question
      await appApi.createPollQuestion(
        newPoll.id,
        question.questionText,
        question.questionType,
        options,
      );
    }

    // Refresh settings to get all the duplicated questions
    await globalSettingsStores.fetchSetting();
    toast.success('המשוב הועתק בהצלחה');
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
